<template>
  <v-container fluid>
    <v-card
      border
      tile
    >
      <v-card-title>
        {{ $bct('My documents') }}
      </v-card-title>

      <v-tabs
        v-model="tab"
        grow
      >
        <v-tab>
          <div class="d-flex align-center ga-2">
            <span>
              {{ $bct('Agreements') }}
            </span>

            <NotificationBadge
              :notification-count="$attrs.notificationItems['agreements']?.length"
              inline
            />
          </div>
        </v-tab>

        <v-tab>
          {{ $bct('Images') }}
        </v-tab>
      </v-tabs>

      <v-divider />

      <v-window v-model="tab">
        <v-window-item>
          <div class="ma-3 d-flex flex-column ga-3">
            <div class="d-flex">
              <v-spacer />

              <v-btn
                @click="loadAgreements"
                :loading="processing"
                color="primary"
                prepend-icon="refresh"
                text="Refresh"
              />
            </div>

            <AgreementTable
              v-if="agreements"
              @change="loadAgreements"
              :agreements="agreements"
              :processing="processing"
              role="manager"
            />
          </div>
        </v-window-item>

        <v-window-item>
          <AssetTable />
        </v-window-item>
      </v-window>
    </v-card>

    <VerticalSpacer :min-height="14" />
  </v-container>
</template>

<script setup>
import { useRoute } from 'vue-router';

import AgreementTable from '@/shared/components/agreement/AgreementTable.vue';
import AssetTable from '@/manager/components/AssetTable.vue';
import NotificationBadge from '@/manager/components/NotificationBadge.vue';
import useApi from '@/shared/composables/useApi';
import VerticalSpacer from '@/shared/components/VerticalSpacer.vue';

const $bct = inject('translator');

const route = useRoute();
const { api: Api } = useApi();

const agreements = ref(null);
const processing = ref(false);
const tab = ref(getTab());

const emit = defineEmits(['update:notifications']);

function getTab() {
  const tabOptions = {
    agreements: 0,
    assets: 1,
  };

  return tabOptions[route.query.tab] || 0;
}

async function load() {
  await loadAgreements();
}

async function loadAgreements() {
  processing.value = true;

  const response = await Api.manager.agreement.index();
  agreements.value = response?.data;

  emit('update:notifications');

  processing.value = false;
}

onMounted(load);
</script>
